module.exports = __webpack_public_path__ + "img/brand-11.b325ea33.png";